

<template>
<div>

  <a-table

    :columns="columns"
    :rowKey="(record) => record.id"
    :dataSource="dataSource"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    class="video-list"
    size="middle"
    bordered
    :locale="mylocale"
  >
    <template slot="cover" slot-scope="record">
      <problem-cover-col :problem="record">
        
      </problem-cover-col>
  
    </template>

    <template slot="number" slot-scope="record">
      {{ record.number }}
    </template>

    <template slot="executive" slot-scope="record">
      {{ record.executive ? record.executive.name : "" }}
    </template>

    <template slot="comptext" slot-scope="record">
      <span>
        {{ record.title.substring(0, 200) }}
        <a-tooltip
          :title="record.title"
          v-if="record.title.length > 200"
          :overlayStyle="{ maxWidth: '500px' }"
        >
          <a-icon class="more-icon" type="small-dash" />
        </a-tooltip>
      </span>
    </template>

    <template slot="sender" slot-scope="record">
      <span v-if="selectedMenu.label === 'received'">
        {{getSharePerson(record.shareInfo.senderUser)}}
      </span>
      <div v-else>
        <div  v-for="u in record.shareInfo.receiverUsers" :key="u.uuid">
            {{getSharePerson(u)}}
        </div>
      </div>
    </template>

    <template slot="daterange" slot-scope="record">
      <div>{{ record.dateStr }}</div>
      <div v-if="record.dateCompleteStr">{{ record.dateCompleteStr }}</div>
    </template>

    <template slot="address" slot-scope="record">
      {{ getAddress(record) }}
    </template>

    <template slot="actions" slot-scope="record">
      <div style="display: flex; flex-direction: column; align-items: center">
        <span
          v-if="!!record.editor && canEdit"
          style="width: 100%; text-align: center"
        >
          {{ record.editor.split(" ")[0] }} {{ record.editor.split(" ")[1] }}
          <br />
          baxır
        </span>

        <a-button
          :style="{ backgroundColor: getColor(record), border: 'none' }"
          @click="goPage(record)"
          type="primary"
          size="small"
        >
          <a-icon :type="canEdit ? 'eye' : 'eye'" />
          {{ canEdit ? "Bax" : "Ətraflı" }}
        </a-button>
      </div>
    </template>
  </a-table>
</div>

</template>

<script>
import mixin from "@/mixins/index";
import { URL } from "@/utils/api";
import ProblemCoverCol from "@/components/partials/ProblemCoverCol";



export default {
  name: "ProblemsTable",
  components: {
    "problem-cover-col": ProblemCoverCol,
  },
  mixins: [mixin],
  props: {
    dataSource: Array,
    loading: Boolean,
    canEdit: Boolean,
    selectedMenu: Object,
    totalCount: Number,
  },
  data() {
 
    return {
      mylocale: { emptyText: "Məlumat yoxdur" },
      pagination: {
        pageSize: 10,
        current: 1,
        position: "both",
        size: "small",
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        locale: {items_per_page: "/ səhifə"},
        showTotal: (total, range) =>
        'Şikayət sayı  -'+this.totalCount ||'',
      },
      prefix: URL[process.env.NODE_ENV].file_url,
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          title: "",
          width: "18%",
          scopedSlots: { customRender: "cover" },
          align: "center",
        },
        {
          title: "Şikayət  mətni",
          width: "20%",
          scopedSlots: { customRender: "comptext" },
          align: "center",
        },
        {
          title: "Yerli icra hakimiyyəti orqanı",
          scopedSlots: { customRender: "executive" },
          width: "15%",
          align: "center",
        },
        {
          title: "Şikayət ünvanı",
          scopedSlots: { customRender: "address" },
          width: this.selectedMenu.shareInfoColVisible ? "15%" : "20%",
          align: "center",
        },
        {
          title: "Şikayət tarixi",
          scopedSlots: { customRender: "daterange" },
          width: this.selectedMenu.shareInfoColVisible ? "15%" : "20%",
          align: "center",
        },
        {
          title: "",
          scopedSlots: { customRender: "actions" },
          width: "7%",
          align: "center",
        },
      ];
 if (window.innerWidth<1100) {
columns = [
 
        {
          title: "Şikayət mətni",
          width: "20%",
          scopedSlots: { customRender: "comptext" },
          align: "center",
        },
        {
          title: "Yerli icra hakimiyyəti orqanı",
          scopedSlots: { customRender: "executive" },
          width: "15%",
          align: "center",
        },
  
   
        {
          title: "",
          scopedSlots: { customRender: "actions" },
          width: "7%",
          align: "center",
        },
      ];
 }

       if (this.selectedMenu.shareInfoColVisible) {
        const receivedTitle = "Müraciəti göndərən";
        const sentTitle = "Müraciəti qəbul edən"
        const title = this.selectedMenu.label === "received" ? receivedTitle : sentTitle;

        columns.splice(1, 0, {
          title,
          scopedSlots: { customRender: "sender" },
          width: "10%",
          align: "center",
        })
      }
 

      return columns;
    }
  },
  methods: {
    getSharePerson(person) {
      return `${person.lastName} ${person.firstName}, ${person.fatherName}`;
    },
    handleTableChange(pagination, filters, sorter) {
     
      this.$emit("change", {
        pagination: pagination,
        filters: filters,
        sorter: sorter,
      });

      this.pagination = { ...pagination };
    },
    getAddress(record) {
      let addr =
        record.region.name +
        (record.street ? "," + record.street.name : "") +
        (record.address
          ? "," + record.address.replace(record.region.name, "")
          : "");
      return addr ? addr.replaceAll(", ,", ",").replace(/,\s*$/, "") : addr;
    },
    goPage(problem) {
      sessionStorage.setItem("problems", JSON.stringify(this.problem));

      if (this.selectedMenu.showInNewTab)
        window.open(this.selectedMenu.url + "/" + problem.id);
      else this.$router.push(this.selectedMenu.url + "/" + problem.id);
      
    },
    getColor(problem) {
      return this.priorityLevels.find(
        (item) => item.name === problem.priorityLevel
      ).color;
    },
  },

  watch: {
    totalCount: function (newVal) {
      this.pagination = { ...this.pagination, total: newVal };
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
